import {Component, input, OnInit, output} from '@angular/core';
import {MdbRippleModule} from "mdb-angular-ui-kit/ripple";
import {TranslateModule} from "@ngx-translate/core";

import {RouterLink, RouterLinkActive} from "@angular/router";
import {SubPageModel} from "../../../models/sub-page.model";
import {RouteHelperService} from "../../../services/utils/route-helper.service";

@Component({
  selector: 'app-btn-group-nav',
  imports: [
    MdbRippleModule,
    TranslateModule,
    RouterLink,
    RouterLinkActive
],
  templateUrl: './btn-group-nav.component.html',
  standalone: true,
  styleUrl: './btn-group-nav.component.scss'
})
export class BtnGroupNavComponent implements OnInit {
  pages = input.required<SubPageModel[]>();
  identifier = input.required<string>();
  activePageChange = output<SubPageModel>();
  activePage?: SubPageModel;
  constructor(private routeHelperService: RouteHelperService) {}

  ngOnInit() {
    this.activePage = this.pages()[0];
  }

  setActive(page: SubPageModel) {
    this.activePage = page;
    this.activePageChange.emit(page);
  }

  isActive(page: SubPageModel) {
    if(page.isBasePage && !this.pages().find(p => this.routeHelperService.lastPartOfUrlIs(p.link)))
      return true
    return this.routeHelperService.lastPartOfUrlIs(page.link?.replaceAll('/', ''));
  }
}
